import { useState } from "react";
import MainLayout from "../../layout/MainLayout";
import { ToggleButton } from "../index";
import ReferralCenter from "./ReferralCenter";
import MyInvites from "./MyInvites";
import QuickActionSelect from "../quick-action-select/QuickActionSelect";

const componentForTab = (tab) =>
  tab === "My Invites" ? <MyInvites /> : <ReferralCenter />;

const InvitePeople = ({ initialTab = "Referral Center" }) => {
  const [selectedComponent, setSelectedComponent] = useState(
    componentForTab(initialTab)
  );

  const onToggle = (value) => {
    switch (value) {
      case "Referral Center":
        setSelectedComponent(<ReferralCenter />);
        break;

      case "My Invites":
        setSelectedComponent(<MyInvites />);
        break;

      default:
        setSelectedComponent(<ReferralCenter />);
    }
  };
  return (
    <MainLayout NavName="Invite People" expand={false}>
      <div>
        <div className="container mt-5">
          <div className="d-flex justify-content-between align-items-center">
            <ToggleButton
              options={["Referral Center", "My Invites"]}
              defaultValue={initialTab}
              onChange={(value) => onToggle(value)}
            />
            <QuickActionSelect />
          </div>

          <div className="row border rounded-3 justify-content-between p-3 mx-1 mt-3">
            {selectedComponent}
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default InvitePeople;
